import { default as calculationFirstStep } from './firstStep';

export const firstStep = {
  ...calculationFirstStep,
};
